import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { mainRoutes } from '../routes/mainRoutes';
import { authRoutes } from '../routes/authRoutes';
import { legalRoutes } from '../routes/legalRoutes';
import { adminRoutes } from '../routes/adminRoutes';
import { FeatureUnavailable } from './common/FeatureUnavailable';

export const AppRoutes: React.FC = () => {
  return (
    <Routes>
      {mainRoutes}
      {authRoutes}
      {legalRoutes}
      {adminRoutes}
      {/* Catch-all: deep-links órfãos (/store antigo etc.) não dão tela vazia */}
      <Route path="*" element={<FeatureUnavailable />} />
    </Routes>
  );
};